{
  "name": "@sap/ux-specification",
  "version": "1.144.2",
  "displayName": "SAP Fiori tools - Specification",
  "description": "SAP Fiori tools - Specification",
  "files": [
    "dist",
    "CHANGELOG.md",
    "!dist/scripts"
  ],
  "main": "dist/index-min.js",
  "engines": {
    "node": ">=20.0.0 <21.0.0 || >=22.0.0 <23.0.0 || >=24.0.0 <25.0.0 || >=26.0.0",
    "yarn": ">=1.22.19 < 2"
  },
  "scripts": {
    "clean:before": "rimraf ./dist ./types ./schemas",
    "clean:doc": "rimraf ./dist/documentation",
    "compile": "tsc --project ./tsconfig.build.json",
    "compile:watch": "tsc --build ./tsconfig.build.json --pretty --watch",
    "bundle": "node esbuild",
    "bundle:dev": "node esbuild --minify=false",
    "bundle:watch": "node esbuild --watch --stats --minify=false",
    "build": "npm-run-all -l -s clean:before -s compile -p create-json-schemas macros copy-templates -p copy-json-schemas -s htmlV2 htmlV4 -s bundle",
    "build:dev": "npm-run-all -l -s clean:before -s compile -p create-json-schemas copy-templates -s copy-json-schemas bundle:dev",
    "build:doc": "npm-run-all -l -s clean:doc -s compile -s htmlV2 htmlV4 -s bundle",
    "build:schemas": "npm-run-all -l -s create-json-schemas copy-json-schemas",
    "build:snap": "yarn build:dev && yarn update-snapshots",
    "create-json-schemas": "ts-node ./scripts/schema/index.ts ",
    "copy-json-schemas": "cpy \"schemas/**\" dist/schemas",
    "copy-templates": "cpy \"src/sync/v2/export/templates/**\" dist/templates --flat",
    "deleteSnapshots": "rimraf **/_file_snapshots_",
    "docuV2": "ts-node ./scripts/extractDocu.ts --version=v2 format=excel",
    "docuV4": "ts-node ./scripts/extractDocu.ts --version=v4 format=excel",
    "validity-report": "ts-node ./scripts/generate-validity-report.ts",
    "htmlV2": "ts-node ./scripts/extractDocu.ts --version=v2 --format=html",
    "htmlV4": "ts-node ./scripts/extractDocu.ts --version=v4 --format=html",
    "lint": "eslint .",
    "lint:summary": "eslint . -f summary",
    "lint:fix": "eslint . --fix",
    "lint:report": "eslint . -f multiple",
    "lint:report:jslint": "eslint . -o reports/lint/eslint.jslint.xml -f jslint-xml",
    "macros": "ts-node ./scripts/macros/index.ts",
    "macros:update": "npm run macros -- --update",
    "test": "jest && node ../../scripts/scov.js reports/test/unit/coverage/lcov.info",
    "test:ci": "node --max-old-space-size=4096 ./node_modules/.bin/jest --ci --forceExit --detectOpenHandles && node ../../scripts/scov.js reports/test/unit/coverage/lcov.info",
    "update-snapshots": "jest --updateSnapshot",
    "watch": "npm-run-all -l -s clean:before -p compile create-json-schemas macros copy-templates -p copy-json-schemas -s bundle:watch",
    "watch:doc": "npm-run-all -l -s clean:doc -s compile -s htmlV2 htmlV4 -s bundle:watch"
  },
  "publisher": "SAPSE",
  "license": "SEE LICENSE IN LICENSE",
  "dependencies": {
    "@sap-ux/fe-fpm-writer": "0.43.21",
    "@sap-ux/vocabularies-types": "0.15.0"
  },
  "devDependencies": {
    "@sap-ux/annotation-converter": "0.10.21",
    "@sap-ux/edmx-parser": "0.10.0",
    "@sap-ux/project-access": "1.35.20",
    "@sap/ux-specification-types": "1.144.2",
    "@sapui5/types": "latest-1.144",
    "@types/d3": "7.4.3",
    "@types/jquery": "3.5.34",
    "@types/json-schema": "7.0.15",
    "@types/mem-fs": "1.1.5",
    "@types/mem-fs-editor": "7.0.1",
    "@ui5/flexibility-utils": "0.1.3",
    "@xml-tools/ast": "5.0.5",
    "@xml-tools/parser": "1.0.11",
    "axios": "1.15.0",
    "cpy-cli": "7.0.0",
    "d3": "7.9.0",
    "deepmerge": "4.3.1",
    "ejs": "3.1.10",
    "eslint-formatter-checkstyle": "9.0.1",
    "excel4node": "1.8.2",
    "i18next": "25.8.18",
    "jquery": "3.7.1",
    "jsdom": "25.0.1",
    "jsonpath-plus": "10.4.0",
    "mem-fs": "2.1.0",
    "mem-fs-editor": "9.7.0",
    "path": "0.12.7",
    "reflect-metadata": "0.2.2",
    "semver": "7.7.4",
    "typescript-json-schema": "0.67.1",
    "xml-js": "1.6.11"
  },
  "husky": {
    "hooks": {
      "pre-commit": "lint-staged"
    }
  },
  "lint-staged": {},
  "jestSonar": {
    "reportFile": "test-report.xml",
    "reportPath": "reports/test/unit"
  },
  "eslint-formatter-multiple": {
    "formatters": [
      {
        "name": "stylish",
        "output": "console"
      },
      {
        "name": "json",
        "output": "file",
        "path": "reports/lint/eslint.json"
      },
      {
        "name": "checkstyle",
        "output": "file",
        "path": "reports/lint/eslint.checkstyle.xml"
      }
    ]
  }
}
